export default __webpack_public_path__ + "static/heroDust-c3d1d6b619603caab3aa47cd0c71ed90.png";